import { TextFilterData } from '../dto/EntityRepository';
import { PerPage } from '../enum/EnumRepository';

export function buildTextListParams(
  aui: string,
  metaData: {
    page: number;
    size: PerPage;
    sortData: { sort: string; direction: 'ASC' | 'DESC'; manualOrderFirst?: boolean };
  },
  filter?: TextFilterData | {},
): URLSearchParams {
  const p = new URLSearchParams();

  p.set('aui', aui);
  p.set('page', String(metaData.page));
  p.set('size', String(metaData.size));
  p.set('sortBy', metaData.sortData.sort);
  p.set('direction', metaData.sortData.direction);
  if (metaData.sortData.manualOrderFirst) p.set('manualOrderFirst', 'true');

  const tagIds = filter && 'tagIds' in filter ? filter.tagIds : undefined;
  const untagged = filter && 'untagged' in filter ? filter.untagged : false;
  if (untagged) {
    p.set('untagged', 'true');
  } else {
    tagIds?.forEach((id) => p.append('tagIds', String(id)));
  }

  return p;
};
